import React from 'react';
import PublicHero from 'components/Publics/PublicHero';

const CBHero = (props) => {
  const {isLoading, data} = props;
  const {files, certification_bodies_name, country_name} = data || {};

  return (
    <PublicHero
      companyType="cb"
      logoFiles={files}
      isLoading={isLoading}
      subtitle={country_name}
      title={certification_bodies_name}
    />
  );
};

export default CBHero;
